export enum Sede {
  'Oficina Central',
  'Compras',
}
